import { ENDPOINTS } from '@api/endpoints';
import api, { handleError } from '@/api';

const { FOLDER } = ENDPOINTS;

export type UserTasksParams = {
  status?: 'PENDING' | 'IN_PROGRESS' | 'COMPLETED' | 'FAILED';
  groupId?: string | number;
};

export default {
  /**
   * Get list of tasks for current user (manager/worker)
   */
  getUserTasks: async (params?: UserTasksParams, signal?: AbortSignal) => {
    try {
      const path = FOLDER.GET_USER_TASKS_LIST.path(params?.status, params?.groupId);
      const response = await api.get<typeof FOLDER.GET_USER_TASKS_LIST.responseType>(path, {
        method: FOLDER.GET_USER_TASKS_LIST.method,
        url: path,
        signal,
      });
      return {
        status: true,
        data: response.data ?? [],
      };
    } catch (error) {
      throw handleError(error);
    }
  },
};
